import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import Link from "./Link";
var propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  active: PropTypes.bool,
  theme: PropTypes.shape({
    navBarListItem: PropTypes.oneOf(['dark'])
  }),

  /** Pass a custom component instead of the default `href` */
  component: PropTypes.oneOfType([PropTypes.elementType, PropTypes.func, PropTypes.string]),

  /** Deprecated. Use `ThemeProvider` instead for custom colors. */
  activeColor: PropTypes.oneOf(['green', 'white']),
  disabled: PropTypes.bool,
  sentenceCase: PropTypes.bool
};
var defaultProps = {
  theme: {},
  component: 'a',
  activeColor: 'green',
  sentenceCase: false
};
var NavBarListItem = React.forwardRef(function (_ref, ref) {
  var id = _ref.id,
      label = _ref.label,
      active = _ref.active,
      disabled = _ref.disabled,
      theme = _ref.theme,
      props = _objectWithoutProperties(_ref, ["id", "label", "active", "disabled", "theme"]);

  if (props.activeColor === 'white') {
    /* eslint-disable-next-line no-console */
    console.warn('Warning: The `activeColor` prop on the `NavBarListItem` component is deprecated and will be removed soon. Use `ThemeProvider` instead for custom colors.');
  }

  return React.createElement(ThemeProvider, {
    theme: theme
  }, React.createElement("li", {
    role: "tab",
    "aria-controls": id,
    "aria-selected": active
  }, React.createElement(Link, Object.assign({
    ref: ref,
    isActive: active,
    isDisabled: disabled
  }, props), label)));
});
NavBarListItem.propTypes = propTypes;
NavBarListItem.defaultProps = defaultProps;
NavBarListItem.displayName = 'NavBarListItem';
NavBarListItem.darkTheme = {
  navBarListItem: 'dark'
};
export default NavBarListItem;